// ============================================================
// Mock Pending Fees Data
// ============================================================
// Scoped by schoolId

import { mockStudents } from './students';

// Dynamically generate pending fees for most students to show varying statuses
const generatedPendingFees = {};

mockStudents.forEach((student, index) => {
  if (!generatedPendingFees[student.schoolId]) {
    generatedPendingFees[student.schoolId] = [];
  }

  // 30% are cleared (no pending fees)
  if (index % 3 === 0) return;

  // Others have some pending fee
  const isOverdue = index % 2 === 0;
  generatedPendingFees[student.schoolId].push({
    id: `pend-${student.id}`,
    studentId: student.admissionNumber,
    studentName: `${student.firstName} ${student.lastName}`,
    gender: student.gender,
    classId: student.classId || 'class-1',
    className: student.className || 'Grade 1',
    sectionName: student.sectionName || 'Section A',
    rollNumber: student.rollNumber || 'N/A',
    feeHeadId: 'fee-str-1',
    feeHeadName: 'Tuition Fee',
    amount: (index % 5 + 1) * 2000,
    dueDate: isOverdue ? '2026-06-15T00:00:00Z' : '2026-08-15T00:00:00Z',
    status: isOverdue ? 'overdue' : 'pending',
  });
});

export const mockPendingFees = generatedPendingFees;
